export default "__VITE_ASSET__BgNfcJvZ__"